var _ = require('lodash-es');

    // Register all routes handled by this module
    angular
    .module('GorillaBoy.DocumentViewer')
    .config(['$routeProvider', function ($routeProvider) {
        var TEMPLATE_LAYOUT = './assets/partials/app/layout.html',
        	FAILED_PASSWORD_ANONYMOUS_ACCESS = 'InvalidPasswordException: Document needs a password.';

        // Angular's resolve hashmap values need to be either Promises or a function.
        // This makes it shorter to generate functions that return a given value.
        function makeReturnFunc(returnValue) {
            return function () { return returnValue; };
        }

        function resolveUserInfo () {
            return ['AuthService', '$location', '$log', '$q', function (authService, $location, $log, $q) {
                return authService.getUserInfo().then(null, function(error) {
                    $log.error("Encountered error while fetching userInfo inside resolveUserInfo of filebrowser module.js");
                    $location.url('/genericError');
                    return $q.reject(error);
                });
            }];
        }

        function resolveDocument () {
            return ['RegionService', 'DocumentService', 'SourceConstant', '$route', '$q', '$uibModal', '$uibModalStack', '$log',
            	function (regionService, documentService, SourceConstant, $route, $q, $uibModal, $uibModalStack, $log) {
                var deferred = $q.defer(),
                    docId = $route.current.params.documentId;

                function getDocumentFunction () {
                    function getDocumentSuccessCallback(response){
                         deferred.resolve(response);
                    }
                    function getDocumentErrorCallback(response){
                        if (response.data && response.data.Message &&
                                response.data.Message === FAILED_PASSWORD_ANONYMOUS_ACCESS) {

                            // This closes all previous modals
                            $uibModalStack.dismissAll();

                            var passwordModal = $uibModal.open({
                                templateUrl: './document-viewer/passcode_modal.html',
                                controller: 'passcodeController',
                                size: 'sl',
                                resolve:{
                                        isAnonymousCall: function(){
                                            return false;
                                        }
                                    }
                                });

                            passwordModal.result.then(function(document) {
                                deferred.resolve(document);
                            }, function() {
                                $log.error("Error loading document with ID : " +
                                    docId + " : " + JSON.stringify(response));
                                var errorObj = {};
                                errorObj.error = response;
                                //Error code to allow user to request access.
                                //423 = Locked
                                errorObj.error.status = 423;
                                deferred.resolve(errorObj);
                            });

                        } else {
                            $log.error("Error loading document with ID : " +
                                docId + " : " + JSON.stringify(response));
                            var errorObj = {};
                            errorObj.error = response;
                            deferred.resolve(errorObj);
                        }
                    }

                    documentService.getDocument(docId, true)
                    .then(getDocumentSuccessCallback, getDocumentErrorCallback);
                }

                regionService.region().then(getDocumentFunction, getDocumentFunction);

                return deferred.promise;
            }];
        }

        function resolveAnonymousDocument () {
            return ['RegionService', 'DocumentService', 'SourceConstant', '$route', '$q', '$location', '$window', '$uibModal', '$uibModalStack', '$rootScope', '$log', 'ClientMetricsService',
            	function (regionService, documentService, SourceConstant, $route, $q, $location, $window, $uibModal, $uibModalStack, $rootScope, $log, ClientMetricsService) {
                var deferred = $q.defer(),
                    docId = $route.current.params.documentId;

                function redirectToLogin() {
                    $log.error("Document can't be seen anonymously");
                    deferred.resolve();
                    //flushLogsToTheServer() is always resolved where as forcePostMetrics() is not. The identity will convert rejection to resolution
                    $q.all([ClientMetricsService.flushLogsToTheServer(), $rootScope.metricServiceInstance.forcePostMetrics().then(null, _.identity)])                
                    .then(doTheRedirect, doTheRedirect);
                    function doTheRedirect() {
                        $window.location.href = $location.absUrl().split('#')[0] + '#/login';
                        $window.location.reload();  
                    }                  
                }

              function getDocumentFunction () {

                    function getDocumentSuccessCallback(response){
                         deferred.resolve(response);
                    }

                    function getDocumentErrorCallback(response){
                    	if (response.data && response.data.Message &&
                    			response.data.Message === FAILED_PASSWORD_ANONYMOUS_ACCESS) {

                    		// This closes all previous modals
                    		$uibModalStack.dismissAll();

                    		var passwordModal = $uibModal.open({
                                templateUrl: './document-viewer/passcode_modal.html',
                                controller: 'passcodeController',
                                size: 'sl',
                                resolve:{
	                            		isAnonymousCall: function(){
	                            			return true;
	                            		}
	                            	}
                    			});

                    		passwordModal.result.then(function(document) {

                    			deferred.resolve(document);

                            }, function() {
                            	redirectToLogin();
                            });

                    	} else {
                    		redirectToLogin();
                    	}
                    }

                    documentService.getDocument(docId, true, null, true)
                    .then(getDocumentSuccessCallback, getDocumentErrorCallback);
                }

                regionService.region().then(getDocumentFunction, getDocumentFunction);

                return deferred.promise;
            }];
        }

        /**
         * Even though all the method calls are triggered at once (resulting in multiple promises to be resolved),
         * the userInfo promise will be synchronously resolved since it maintains a local cache of User object
         */
        function resolveForDocumentView () {
            return {
                Anonymous: makeReturnFunc(false),
                userInfo: resolveUserInfo(),
                Document: resolveDocument(),
                featureMap: ['FeatureManagerService', '$location', '$log', '$q', function (featureManagerService, $location, $log, $q) {
                    return featureManagerService.getEnabledFeatureMap()
                        .then(null, function(error) {
                            $log.error("Encountered error while fetching feature map of documentviewer module.js");
                            $location.url('/genericError');
                            return $q.reject(error);
                        });
                }]
            };
        }

        function resolveForQuartzDocumentView() {
          return {
            Anonymous: makeReturnFunc(false),
            userInfo: resolveUserInfo(),
            featureMap: [
              "FeatureManagerService",
              "$location",
              "$log",
              "$q",
              function (featureManagerService, $location, $log, $q) {
                return featureManagerService
                  .getEnabledFeatureMap()
                  .then(null, function (error) {
                    $log.error(
                      "Encountered error while fetching feature map of documentviewer module.js"
                    );
                    $location.url("/genericError");
                    return $q.reject(error);
                  });
              },
            ],
          };
        }

        function resolveForAnonymousDocumentView () {
            return {
                Anonymous: makeReturnFunc(true),
                userInfo: makeReturnFunc(false),
                Document: resolveAnonymousDocument(),
                featureMap: ['FeatureManagerService', function (featureManagerService) {
                    return featureManagerService.getAnonymousFeatureMap();
                }]
            };
        }

        $routeProvider
        .when('/document/:documentId', {
            templateUrl: TEMPLATE_LAYOUT,
            controller: 'DocumentController',
            auth: true,
            resolve: resolveForDocumentView()
        })
        .when("/quartz/:documentId", {
          templateUrl: TEMPLATE_LAYOUT,
          controller: "QuartzDocumentController",
          auth: true,
          resolve: resolveForQuartzDocumentView(),
        })
        .when('/share/document/:documentId?', {
            templateUrl: TEMPLATE_LAYOUT,
            controller: 'DocumentController',
            resolve: resolveForAnonymousDocumentView()
        });
    }]);
